module.exports = __webpack_public_path__ + "static/blackhawkBankTrust-cb40a7e607549537462b94690c61c033.png";